import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { DateRangeFilterModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/models/inputs/date-range-filter.model';
import { format } from 'date-fns';

interface DateRangeFilterStateControllerProps {
  icon: string;
  fromLabel: string;
  toLabel: string;
  value: DateRangeFilterModel;
  onRemove: FilteredItemProps['onRemove'];
}

export const DateRangeFilterStateController = ({
  icon,
  fromLabel,
  toLabel,
  value,
  onRemove,
}: DateRangeFilterStateControllerProps): React.JSX.Element => {
  // DATA FETCHING /////////////////////////////////////////////////////////////

  const from = value.min ? format(value.min, 'yyyy-MM-dd') : undefined;
  const to = value.max ? format(value.max, 'yyyy-MM-dd') : undefined;

  const label = [from && `${fromLabel} ${from}`, to && `${toLabel} ${to}`]
    .filter(Boolean)
    .join(' — ');

  // RENDER ////////////////////////////////////////////////////////////////////

  return <FilteredItem icon={icon} label={label} onRemove={onRemove} />;
};
